import { useEffect, useRef, useState } from "react";
import { getVolume, setVolume, subscribeVolume } from "../lib/audio";

export default function VolumeControl() {
  const [volume, setLocal] = useState(getVolume);
  const previous = useRef(volume || 0.8);

  useEffect(() => subscribeVolume(setLocal), []);

  function change(next: number) {
    if (next > 0) previous.current = next;
    setVolume(next);
  }

  const muted = volume === 0;
  const pct = Math.round(volume * 100);

  return (
    <div
      className="volume-ctl flex items-center gap-2 min-w-0"
      role="group"
      aria-label="Volume"
    >
      <button
        type="button"
        className="shrink-0 rounded-full w-10 h-10 grid place-items-center border border-cream/25 bg-ink-2"
        onClick={() => change(muted ? previous.current || 0.8 : 0)}
        aria-label={muted ? "Réactiver le son" : "Couper le son"}
        title={muted ? "Réactiver le son" : "Couper le son"}
      >
        {muted ? (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
            <path d="M4 10v4h4l5 4V6L8 10H4z" fill="currentColor" opacity="0.45" />
            <path d="M16 9l6 6M22 9l-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        ) : (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
            <path d="M4 10v4h4l5 4V6L8 10H4z" fill="currentColor" />
            <path d="M16 9.5a4 4 0 0 1 0 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            {volume > 0.45 && (
              <path d="M18.5 7a7 7 0 0 1 0 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            )}
          </svg>
        )}
      </button>
      <input
        type="range"
        min={0}
        max={100}
        value={pct}
        onChange={(e) => change(Number(e.target.value) / 100)}
        aria-label="Niveau du volume"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={pct}
        className="volume-slider w-28 sm:w-40"
      />
      <span className="tabular-nums text-xs w-8 text-cream/80" aria-hidden>
        {pct}
      </span>
    </div>
  );
}
